import { useState, useEffect, useCallback } from "react";
import { fleetService } from "../../api/fleetService/fleetServicesRegistered";

const useFleetInfo = (businessProfile: any) => {
    const [vehiclePlates, setVehiclePlates] = useState<string[]>([]);
    const [trailerPlates, setTrailerPlates] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchFleetInfo = useCallback(async () => {
        if (!businessProfile?.legacycodes?.length) {
            console.warn("Nessun legacycode disponibile");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const vehiclesRes = await fleetService.getFleetInfoBySupplier(
                businessProfile.legacycodes[0].legacycode,
                businessProfile.legacycodes[0].company
            );

            if (!vehiclesRes.fleet) {
                console.warn("Nessun dato disponibile nella fleet");
                setVehiclePlates([]);
                setTrailerPlates([]);
                return;
            }

            // Estrarre le targhe dei veicoli (Truck)
            const vehiclePlatesList = vehiclesRes.fleet.Vehicle
                ? Object.values(vehiclesRes.fleet.Vehicle) // Prendiamo tutti i gruppi di veicoli
                      .flat()
                      .filter((vehicle:any)=>vehicle.status === "ACTIVE")
                      .map((vehicle: any) => vehicle.licensePlate)
                      .filter(Boolean) // Rimuove valori null/undefined
                : [];

            // Estrarre le targhe dei trailer
            const trailerPlatesList = vehiclesRes.fleet.Trailer
                ? Object.values(vehiclesRes.fleet.Trailer) // Prendiamo tutti i gruppi di trailer
                      .flat()
                      .filter((trailer:any)=>trailer.status === "ACTIVE")
                      .map((trailer: any) => trailer.licensePlate)
                      .filter(Boolean) // Rimuove valori null/undefined
                : [];

            console.log("vehiclePlatesList", vehiclePlatesList)
            console.log("trailerPlatesList", trailerPlatesList)

            setVehiclePlates(vehiclePlatesList);
            setTrailerPlates(trailerPlatesList);

        } catch (err) {
            console.error("Errore nel recupero dei veicoli:", err);
            setError("Errore nel recupero dei veicoli");
        } finally {
            setLoading(false);
        }
    }, [businessProfile]);

    useEffect(() => {
        fetchFleetInfo();
    }, [fetchFleetInfo]);

    return { vehiclePlates, trailerPlates, loading, error, fetchFleetInfo };
};

export default useFleetInfo;
